const useProductDetailsLink = (
    id: string,
    variants?: { sku?: string; variantSku?: string; id: string }[],
    activeSKU?: string
) => {
    let productDetailsLink = `/product/${id}`;
    if (activeSKU) {
        const activeVariant = variants?.find(
            variant => (variant.sku || variant.variantSku) === activeSKU
        );
        if (activeVariant) {
            productDetailsLink = `/product/${id}/${activeVariant.id}`;
        }
    }

    return productDetailsLink;
};

export default useProductDetailsLink;
